import { Patient } from "../patient";
import { User } from "../user";
import { Department } from "../department";

export class ExternalScriptParameter {
  /**
   * 外部処理・外部データを処理するのに必要なパラメータを格納する。
   * 一時ファイルのパス・起動引数などに値を埋め込む処理に使用している
   */
  constructor(
    public patient: Patient,
    public user: User,
    public department: Department,
    public orderNo: string,
    public formatId: number,
    public hisInfoGetterParameter: string,
  ) {
  }
}
